import React, { useState } from 'react';
import { OptionalExtraType } from 'Components/Types';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import styled from 'styled-components';
import AdditionalExtras from './AdditionalExtras';
import HomeDetailsForm from './HomeDetailsForm';
import MainDetailsForm from './MainDetailsForm';
import { useMsal } from '@azure/msal-react';
import { setCurrentBooking } from 'features/Booking-Slice';
import { BookingAPI } from 'API/BookingAPI';

type FormsContainerProps = {
    setOptionalExtras: (optionalExtras: OptionalExtraType[]) => void;
}
const Container = styled.div`
    padding: 10px;
    width: 100%;
    @media (min-width: 800px) {
        width: 60%;
    } 
`;
function FormsContainer({ setOptionalExtras }: FormsContainerProps) {
    const { instance } = useMsal();
    const { currentBooking  } = useSelector((state: RootState) => state.booking);
    const dispatch = useDispatch();
    const [waitingForServer, setwaitingForServer] = useState<boolean>(false);
    
    const updateOptionalExtras = async (optionalExtrasList: OptionalExtraType[]) => {
        try{
            const response = await BookingAPI.getSingle(instance, currentBooking?.booking_id ?? 0);
            const booking:any = {...currentBooking};
            if (booking) {
                booking.total_cost = response.booking.total_cost;
                booking.optional_extras = optionalExtrasList;
                dispatch(setCurrentBooking(booking));
            }
        }
        finally
        {
            setOptionalExtras(optionalExtrasList);
            setwaitingForServer(false);
        }
       

    }

    return (
        <Container>
            <MainDetailsForm />
            <HomeDetailsForm />
            {currentBooking && currentBooking?.booking_id > 0 &&
                <AdditionalExtras
                    setOptionalExtras={updateOptionalExtras}
                    setwaitingForServer={setwaitingForServer}
                    waitingForServer={waitingForServer}
                />
            }
        </Container>
    );
}
export default FormsContainer;
